// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .carrot-down-icon {
    display: inline-block;
    cursor: pointer;
    margin-left: 9px;
    transform: rotate(0deg);
    transition: transform 0.1s linear;
  }
  .carrot-up-icon {
    display: inline-block;
    cursor: pointer;
    margin-left: 9px;
    transform: rotate(180deg);
    transition: transform 0.15s linear;
  }
  .zipcode-value {
    margin-left: 7px;
  }
  .zipcode-anchor {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export default styles;
